import React, { useRef } from "react";
import { Box, Card } from "@curves/ui-base";
import useEChart from "@util/hook/useEChart";
import ChartSkeletonLoading from "@icoach/dashboard/ChartSkeletonLoading";

/********* 會員管道來源 *********/
const MemberAcquisitionSourceChart = React.forwardRef((props, ref) => {
	const chartDomRef = useRef(null);
	const {
		sourceData = {
			axis: {
				labels: ["網路廣告", "既有名單", "招牌", "策略夥伴", "自店社群", "CP", "平面媒體", "自店 BR", "他店 BR"],
			},
			series: { data: [117, 75, 50, 45, 35, 20, 10, 10, 7] },
		},
	} = props;
	const { axis = {}, series = {} } = sourceData;
	const axisLabels = axis?.labels ?? [];
	const seriesData = series?.data ?? [];
	const isLoading = seriesData.length === 0;
	const title = "會員管道來源";
	const subTitle = "全體會員入會管道分布統計";

	const option = {
		title: {
			left: 24,
			top: 20,
			text: title,
			textStyle: {
				fontSize: 20,
				fontWeight: 600,
				color: "#1F2937",
			},
			subtext: subTitle,
			subtextStyle: {
				fontSize: 14,
				color: "#64748B",
				padding: [8, 0, 0, 0],
			},
		},

		grid: {
			left: 150,
			right: 40,
			top: 100,
			bottom: 30,
		},

		tooltip: {
			trigger: "axis",
			axisPointer: {
				type: "shadow",
			},
			formatter: params => {
				const item = params[0];
				return `${item.name}<br/>${item.marker} ${item.value} 人`;
			},
		},

		xAxis: [
			{
				type: "value",
				axisLabel: { show: false },
				axisTick: { show: false },
				axisLine: { show: false },
				splitLine: { show: false },
			},
		],

		yAxis: [
			{
				type: "category",
				inverse: true, // 反轉
				data: axisLabels,
				axisLabel: {
					fontSize: 14,
					color: "#374151",
					margin: 8,
				},
				axisTick: { show: false },
				axisLine: { show: true },
				splitLine: { show: false },
			},
		],

		series: [
			{
				name: "Value",
				type: "bar",
				barWidth: "60%",
				data: seriesData,
				itemStyle: {
					borderRadius: [0, 6, 6, 0],
					color: "rgb(148, 163, 184)",
				},
			},
		],
	};

	useEChart(chartDomRef, option);

	return (
		<Card style={{ width: "100%", height: "100%" }}>
			<Card.CardContent style={{ width: "100%", height: "100%" }}>
				{isLoading ? <ChartSkeletonLoading /> : <Box ref={chartDomRef} style={{ width: "100%", height: "100%" }}></Box>}
			</Card.CardContent>
		</Card>
	);
});

export default MemberAcquisitionSourceChart;
